<header class="pheader">
    <dx-toolbar class="header-toolbar shadow Border-primary">
        <dxi-item location="before" cssClass="header-title">
            <!-- <div class="image" [style.background-image]="'url(' + home.ImageSrc + ')'"></div> -->
            <div class="image-container">
                <!-- <div class="user-image" [style.background-image]="'url(' + getIMG + ')'">
                </div> -->
                <img src="assets/img/StaffingGo.png" alt="Header" height="40px" class="img-responsive"
                    *ngIf="isShowImgLogo === false">
                <img [src]="getIMG | safe:'resourceUrl'" alt="Header" height="40px" class="img-responsive"
                    *ngIf="isShowImgLogo === true">
            </div>
        </dxi-item>
        <dxi-item location="center" cssClass="header-title d-md-block" [text]="hederInfo.customerName"
            *ngIf="hederInfo && hederInfo.customerName">
        </dxi-item>
        <dxi-item location="center" cssClass="header-title d-md-block" [text]="currentTitle"
            *ngIf="hederInfo && !hederInfo.customerName">
        </dxi-item>
    </dx-toolbar>
</header>